// @flow strict
import * as React from 'react';
import { RouteLoading } from './components/RouteLoadBoundary/index.js';
import loadable from '@loadable/component';

// Keep explicit names in sync with the server registry. Only the rendered route is preloaded.
const scenes = {
  DestinationPage: loadable(
    () =>
      import(/* webpackChunkName: "page-destination" */ './scenes/DestinationPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  DestinationsPage: loadable(
    () =>
      import(/* webpackChunkName: "page-destinations" */ './scenes/DestinationsPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  ImprintPage: loadable(
    () => import(/* webpackChunkName: "page-imprint" */ './scenes/ImprintPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  PrivacyPolicyPage: loadable(
    () =>
      import(
        /* webpackChunkName: "page-privacy-policy" */ './scenes/PrivacyPolicyPage/index.js'
      ),
    { fallback: <RouteLoading /> },
  ),
  TermsAndConditionsPage: loadable(
    () =>
      import(
        /* webpackChunkName: "page-terms-and-conditions" */ './scenes/TermsAndConditionsPage/index.js'
      ),
    { fallback: <RouteLoading /> },
  ),
  AuthorPage: loadable(
    () => import(/* webpackChunkName: "page-author" */ './scenes/AuthorPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  NotFoundPage: loadable(
    () => import(/* webpackChunkName: "page-not-found" */ './scenes/NotFoundPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  LandingPage: loadable(
    () => import(/* webpackChunkName: "page-landing" */ './scenes/LandingPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  PoiPage: loadable(
    () => import(/* webpackChunkName: "page-poi" */ './scenes/PoiPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  SearchResultsPage: loadable(
    () =>
      import(
        /* webpackChunkName: "page-search-results" */ './scenes/SearchResultsPage/index.js'
      ),
    { fallback: <RouteLoading /> },
  ),
  CategoryPage: loadable(
    () => import(/* webpackChunkName: "page-category" */ './scenes/CategoryPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  SubCategoryPage: loadable(
    () =>
      import(/* webpackChunkName: "page-sub-category" */ './scenes/SubCategoryPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  PoiCategoryPage: loadable(
    () =>
      import(/* webpackChunkName: "page-poi-category" */ './scenes/PoiCategoryPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  TourForwardPage: loadable(
    () =>
      import(/* webpackChunkName: "page-tour-forward" */ './scenes/TourForwardPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  GroupTourPage: loadable(
    () => import(/* webpackChunkName: "page-group-tour" */ './scenes/GroupTourPage/index.js'),
    { fallback: <RouteLoading /> },
  ),
  PoiToursSectionPage: loadable(
    () =>
      import(
        /* webpackChunkName: "page-poi-tours-section" */ './scenes/PoiToursSectionPage/index.js'
      ),
    { fallback: <RouteLoading /> },
  ),
  AiPage: loadable(() => import(/* webpackChunkName: "page-ai" */ './scenes/AiPage/index.js'), {
    fallback: <RouteLoading />,
  }),
  MagazineIndexPage: loadable(
    () =>
      import(
        /* webpackChunkName: "page-magazine-index" */ './scenes/MagazineIndexPage/index.js'
      ),
    { fallback: <RouteLoading /> },
  ),
  MagazineArticlePage: loadable(
    () =>
      import(
        /* webpackChunkName: "page-magazine-article" */ './scenes/MagazineArticlePage/index.js'
      ),
    { fallback: <RouteLoading /> },
  ),
};

export default scenes;
